import React from 'react';
import ContactSection from '../GetInTouch';
import HeroBanner from './HeroBanner';
import HowItWorksSection from './HowItWorksSection';
import MissionVisionSection from './MissionVisionSection';
import SmartSolutionsCarousel from './SmartSolutionsCarousel';
import SmartSolutionsOverview from './SmartSolutionsOverview';
import TrackAnalyzeSection from './TrackAnalyzeSection';
import FuelMonitoringSection from './FuelMonitoringSection';
import TestimonialsSection from './TestimonialsSection';
import IndustrySolutionsSlider from "./IndustrySolutionsSlider";
import PanIndiaSupportSection from "./PanIndiaSupportSection";
import SupportBannerSection from "./SupportBannerSection";
import TrustedLovedSection from "./TrustedLovedSection";

import homeFuelImage from '../../assets/nfuelmonitoring.png';
import homeAutomationImage from '../../assets/fuel-control.png';
import homeDeviceImage from '../../assets/device.png';
import constructionFuel from "../../assets/nconstruction.png";
import aisDevice from "../../assets/ais-140.png";
import wasteManagement from "../../assets/homesmartwaste.png";
import vehicleTracking from "../../assets/homeVehicletracking.png";
import consignmentTracking from "../../assets/consignment.png";
import videoTelematics from "../../assets/videotrack.png";
import schoolMonitoring from "../../assets/schoolbus.png";



const homeSolutionImages = {
  fuelMonitoring: homeFuelImage,
  fuelAutomation: homeAutomationImage,
  constructionFuel: constructionFuel,
  aisDevice: aisDevice,
  wasteManagement: wasteManagement,
  vehicleTracking: vehicleTracking,
  consignmentTracking: consignmentTracking,
  videoTelematics: videoTelematics,
  schoolMonitoring: schoolMonitoring,
};

function Hero() {
  return (


    <main className="bg-white text-[#2a201b]">
      <HeroBanner />
      <SmartSolutionsCarousel pageImages={homeSolutionImages} />
      <TrackAnalyzeSection />
      <FuelMonitoringSection />
      <IndustrySolutionsSlider />
      <PanIndiaSupportSection />
      <SupportBannerSection />
      <TrustedLovedSection />
      {/* <SmartSolutionsOverview /> */}
      {/* <HowItWorksSection /> */}
      <TestimonialsSection />
      <MissionVisionSection />
      <ContactSection />
    </main>
  );
}

export default Hero;
